import { render } from "./BaseRange.vue?vue&type=template&id=0e56a565&scoped=true"
import script from "./BaseRange.vue?vue&type=script&lang=js"
export * from "./BaseRange.vue?vue&type=script&lang=js"

import "./BaseRange.vue?vue&type=style&index=0&id=0e56a565&scoped=true&lang=css"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e56a565"]])

export default __exports__